<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">tune</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Par&aacute;metros Tasa Bol&iacute;vares</h1>
  </div>

  <!-- Card Tabla -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">table_chart</mat-icon>
          Tasas del D&iacute;a
        </h2>
        <button type="button" (click)="reload()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">refresh</mat-icon>
          Refrescar
        </button>
      </div>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto" *ngIf="dataSource">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <!-- ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">ID</th>
          <td mat-cell *matCellDef="let row" class="font-mono text-xs font-bold">{{ row.id }}</td>
        </ng-container>

        <!-- Nombre -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Nombre</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.nombre }}</td>
        </ng-container>

        <!-- Descripcion -->
        <ng-container matColumnDef="descripcion">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Descripci&oacute;n</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.descripcion }}</td>
        </ng-container>

        <!-- Origen -->
        <ng-container matColumnDef="origen">
          <th mat-header-cell *matHeaderCellDef style="min-width: 80px;">Origen</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-semibold">{{ row.origen }}</td>
        </ng-container>

        <!-- Destino -->
        <ng-container matColumnDef="destino">
          <th mat-header-cell *matHeaderCellDef style="min-width: 80px;">Destino</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-semibold">{{ row.destino }}</td>
        </ng-container>

        <!-- Tasa (editable) -->
        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Tasa</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.isEditing">
              <input [(ngModel)]="row.tasa" type="text"
                style="width: 100px; padding: 4px 8px; border: 2px solid #34d399; border-radius: 6px; font-size: 0.8rem; font-weight: 700; color: #1e5a3f; outline: none;" />
            </ng-container>
            <ng-container *ngIf="!row.isEditing">
              <span style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">{{ row.tasa }}</span>
            </ng-container>
          </td>
        </ng-container>

        <!-- Rango -->
        <ng-container matColumnDef="rango">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Rango</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.rango }}</td>
        </ng-container>

        <!-- Perfil -->
        <ng-container matColumnDef="perfil">
          <th mat-header-cell *matHeaderCellDef style="min-width: 80px;">Perfil</th>
          <td mat-cell *matCellDef="let row">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">{{ row.perfil }}</span>
          </td>
        </ng-container>

        <!-- Responsable -->
        <ng-container matColumnDef="responsable">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Responsable</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.responsible }}</td>
        </ng-container>

        <!-- Acciones -->
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="text-align: center; min-width: 80px;">Acciones</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <div style="display: flex; gap: 4px; justify-content: center;">
              <button *ngIf="!row.isEditing" title="Editar" (click)="editRow(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
              </button>
              <button *ngIf="row.isEditing" title="Guardar" (click)="saveRow(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
                onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">save</mat-icon>
              </button>
              <button *ngIf="row.isEditing" title="Cancelar" (click)="cancelEdit(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">close</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden p-4 space-y-3" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.data; let i = index"
        class="bg-white rounded-xl border transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">
        <!-- Card Header -->
        <div class="flex items-center justify-between p-3 cursor-pointer" (click)="toggleCard(i)">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <span class="inline-block text-xs font-bold px-2 py-0.5 rounded-full bg-green-100 text-green-800 font-mono">#{{ row.id }}</span>
            <span class="text-sm font-semibold text-gray-800 truncate">{{ row.nombre }}</span>
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">{{ row.perfil }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span style="font-weight: 700; color: #1e5a3f; font-size: 0.85rem;">{{ row.tasa }}</span>
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #6b7280; transition: transform 0.2s;"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">expand_more</mat-icon>
          </div>
        </div>
        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" class="border-t border-gray-100 p-3">
          <div class="grid grid-cols-2 gap-3 text-sm mb-3">
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Descripci&oacute;n</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.descripcion }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Rango</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.rango }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Origen</span>
              <p class="text-gray-800 font-semibold mt-0.5">{{ row.origen }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Destino</span>
              <p class="text-gray-800 font-semibold mt-0.5">{{ row.destino }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 text-xs font-semibold uppercase">Responsable</span>
              <p class="text-gray-800 font-medium mt-0.5 truncate">{{ row.responsible }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 text-xs font-semibold uppercase">Tasa</span>
              <ng-container *ngIf="row.isEditing">
                <input [(ngModel)]="row.tasa" type="text"
                  style="width: 100%; padding: 4px 8px; border: 2px solid #34d399; border-radius: 6px; font-size: 0.85rem; font-weight: 700; color: #1e5a3f; outline: none; margin-top: 4px;" />
              </ng-container>
              <ng-container *ngIf="!row.isEditing">
                <p style="font-weight: 700; color: #1e5a3f; font-size: 0.9rem; margin-top: 2px;">{{ row.tasa }}</p>
              </ng-container>
            </div>
          </div>
          <!-- Botones acción -->
          <div class="flex gap-2 pt-2 border-t border-gray-100">
            <button *ngIf="!row.isEditing" type="button" (click)="editRow(row); $event.stopPropagation()"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
              Editar
            </button>
            <button *ngIf="row.isEditing" type="button" (click)="saveRow(row); $event.stopPropagation()"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">save</mat-icon>
              Guardar
            </button>
            <button *ngIf="row.isEditing" type="button" (click)="cancelEdit(row); $event.stopPropagation()"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">close</mat-icon>
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
